/**
 * Pre-cache de medios usando Cache API directamente.
 * El service worker ya tiene runtime caching para *.cloudfront.net,
 * pero acá hacemos pre-fetch programado de los próximos items para que
 * la transición sea instantánea aunque el internet se caiga justo antes.
 */

const CACHE_NAME = 'signage-precache-v1';
const MAX_CACHED_ITEMS = 100;

export async function precacheMedia(urls: string[]): Promise<void> {
  if (!('caches' in window)) return;
  const cache = await caches.open(CACHE_NAME);

  const responses = await Promise.allSettled(
    urls.map(async (url) => {
      const existing = await cache.match(url);
      if (existing) return;
      const res = await fetch(url, { mode: 'cors' });
      if (res.ok) await cache.put(url, res);
    }),
  );

  // Limpieza LRU básica — si el cache crece, borramos las más viejas.
  // Cache API no tiene LRU nativa, pero podemos contar y bajar.
  const keys = await cache.keys();
  if (keys.length > MAX_CACHED_ITEMS) {
    const toDelete = keys.slice(0, keys.length - MAX_CACHED_ITEMS);
    await Promise.all(toDelete.map((k) => cache.delete(k)));
  }

  return responses
    .filter((r) => r.status === 'rejected')
    .forEach((r) => {
      // eslint-disable-next-line no-console
      console.warn('Pre-cache failed:', (r as PromiseRejectedResult).reason);
    });
}

export async function invalidateMedia(url: string): Promise<void> {
  if (!('caches' in window)) return;
  const cache = await caches.open(CACHE_NAME);
  await cache.delete(url);
}
